/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './Dropdown.scss';

import React, { useState } from 'react';
const Option = ({
  option,
  onClick,
  index,
  className,
  selectedOption,
  base = false,
  footer = false
}) => {
  function onClickIntercept() {
    onClick && onClick.apply(this, arguments);
  }

  return (
    <a
      className={`option ${
        selectedOption?.title === option?.title ? 'selected' : ''
      } ${className ? className : ''} `}
      id={`option-${base ? 'base' : footer ? 'footer' : index}`}
      value={index}
      onClick={onClickIntercept}>
      {option.title}
      {option.text && <p>{option.text}</p>}
    </a>
  );
};

const Dropdown = ({
  options,
  onChange,
  selected,
  hasFooter = false,
  footerName = '',
  footerLink = ''
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggle = () => setExpanded((prev) => !prev);
  const close = () => setExpanded(false);

  const handleSelection = (e) => {
    e.preventDefault();

    const index = e.currentTarget.getAttribute('value');
    const current = options[index];

    close();

    if (current.value && current.value !== selected.value) {
      if (onChange) {
        onChange.call(e.currentTarget, e, current);
      }
    }
  };

  const onClickFooter = () => {
    if (window && window.location && window.location.href) {
      window.location.href = footerLink;
    }
  };

  const current = selected ? selected : options[0];

  return (
    <div className="dropdown" tabIndex={0} onBlur={close}>
      <Option
        base={true}
        className="selection blocked_data"
        option={current}
        onClick={toggle}
      />
      <div
        className={`options ${expanded ? 'active' : 'inactive'} blocked_data`}>
        {options.map((option, i) => (
          <Option
            key={i}
            index={i}
            onClick={handleSelection}
            option={option}
            selectedOption={current}
          />
        ))}
        {hasFooter && (
          <Option
            className="dropdown-footer"
            option={{ title: footerName }}
            onClick={onClickFooter}
            footer={true}
          />
        )}
      </div>
    </div>
  );
};

export default Dropdown;
